import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { app } from "../config";
import { isDemoMode } from "../../demo/isDemoMode";
import demoStore from "../../demo/demoStore";

const db = getFirestore(app);

const getUserEvents = async (userId) => {
    try {
        // Validate the userId input
        if (!userId) {
            console.error("No userId provided.");
            return "Error: No userId provided.";
        }

        if (isDemoMode) {
            // Demo mode: read from demoStore
            const allEvents = demoStore.getDocs('events', [
                { type: 'where', field: 'userId', op: '==', value: userId }
            ]);

            if (allEvents.length === 0) {
                console.log("No events found for the given userId in demo mode.");
                return [];
            }

            const eventsData = allEvents.map(({ id, data }) => {
                const eventData = {
                    id,
                    ...data,
                };

                // Get registrations for this event from demoStore
                const registrations = demoStore.getDocs('mpsEventRegistration', [
                    { type: 'where', field: 'eventId', op: '==', value: id }
                ]).map(reg => ({
                    id: reg.id,
                    ...reg.data,
                }));

                eventData.mpsregistrations = registrations;
                return eventData;
            });

            return eventsData;
        }

        // Production: Query Firestore
        // Query the "events" collection for documents where "userId" matches the provided userId
        const eventsQuery = query(
            collection(db, "events"),
            where("userId", "==", userId)
        );

        const querySnapshot = await getDocs(eventsQuery);

        if (!querySnapshot.empty) {
            // Map through each event document
            const eventsData = await Promise.all(
                querySnapshot.docs.map(async (docItem) => {
                    const eventData = {
                        id: docItem.id,
                        ...docItem.data(),
                    };

                    // Query the "mpsEventRegistration" collection for all records where "eventId" matches the current event ID
                    const registrationsQuery = query(
                        collection(db, "mpsEventRegistration"),
                        where("eventId", "==", eventData.id)
                    );

                    const registrationsSnapshot = await getDocs(registrationsQuery);

                    // Map through the registration documents to build an array of records
                    const registrations = registrationsSnapshot.docs.map((regDoc) => ({
                        id: regDoc.id,
                        ...regDoc.data(),
                    }));

                    // Add the registrations array to the eventData object
                    eventData.mpsregistrations = registrations;

                    return eventData;
                })
            );

            return eventsData;
        } else {
            console.log("No events found for the given userId.");
            return [];
        }
    } catch (error) {
        console.error("Error fetching events:", error);
        return `Error: ${error.message}`;
    }
};

export { getUserEvents };
